export interface TaxCalculationResult {
  unitCost: number;
  unitCostWithIva: number;
  ivaUnit: number;
  ivaTotal: number;
  totalCost: number;
}

/**
 * Calcula IVA y totales a partir del costo unitario y cantidad.
 */
export const calculateTaxValues = (
  unitCost: number,
  quantity: number,
  taxRate = 0.13
): TaxCalculationResult => {
  const ivaUnit = unitCost * taxRate;
  const ivaTotal = ivaUnit * quantity;
  const unitCostWithIva = unitCost + ivaUnit;
  const totalCost = unitCostWithIva * quantity;

  return {
    unitCost: parseFloat(unitCost.toFixed(10)),
    unitCostWithIva: parseFloat(unitCostWithIva.toFixed(10)),
    ivaUnit: parseFloat(ivaUnit.toFixed(10)),
    ivaTotal: parseFloat(ivaTotal.toFixed(10)),
    totalCost: parseFloat(totalCost.toFixed(10)),
  };
};

/**
* Calcula totales con base en monto neto (sin IVA) para formularios de descuento.
*/
export function calculateDiscountTotal(netAmount: number) {
  const iva = +(netAmount * 0.13).toFixed(2);
  const total = +(netAmount + iva).toFixed(2);
  return { iva, total };
}